import { connect } from 'react-redux';

// Selectors:
import { getIsMobile } from 'src/store/view/selectors';
import {
  penalizedHotelsSelector,
  penalizedHotelsVisibleLimitSelector,
} from '../../../../store/emptyFiltration/selectors';

import { PenalizedHotels as Component } from './PenalizedHotels';

const mapStateToProps = (state) => ({
  isMobile: getIsMobile(state),
  hotels: penalizedHotelsSelector(state),
  visibleLimit: penalizedHotelsVisibleLimitSelector(state),
});

const PenalizedHotels = connect(mapStateToProps)(Component);

export default PenalizedHotels;
